var map = {
	"./feature-01.png": 2580,
	"./feature-02.png": 25039,
	"./feature-03.png": 39942,
	"./feature-04.png": 44921,
	"./feature-05.png": 29168,
	"./feature-06.png": 94571,
	"./feature-07.png": 30914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73646;